import React from 'react'
import { ModelWithForm } from '@morningtrain/react-resources'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as UI from 'ui'
import PersonalInformationFieldset from 'pages/app/users/partials/PersonalInformationFieldset'
import ContactInformationFieldset from 'pages/app/users/partials/ContactInformationFieldset'
import EmploymentInformationFieldset from 'pages/app/users/partials/EmploymentInformationFieldset'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import UserContractsView from 'pages/app/users/partials/views/UserContractsView'
import { Theme, TriggerPipelineOnBeforeThemeChange, WhenTheme } from 'widgets/theme-switcher'
import ManageUserPageHeader from 'pages/app/users/partials/ManageUserPageHeader'
import RedirectToEditOnCreatePipeline from 'support/pipelines/RedirectToEditOnCreatePipeline'
import UserWorkPermitsView from 'pages/app/users/partials/views/UserWorkPermitsView'
import ConfirmFormChanges from 'support/pipelines/ConfirmFormChanges'
import SystemAccessFieldset from 'pages/app/users/partials/SystemAccessFieldset'
import SalaryInformationFieldset from 'pages/app/users/partials/SalaryInformationFieldset'
import { Pipeline } from '@morningtrain/react-helpers'
import { ResetSmartviewOnPipe } from '@morningtrain/react-smartviews'

export default function ManageUser ({ create = false }) {
  return (
          <AdminPageWithSmartview slideInSmartview withGlobalDepartmentFilter={false}>
            <Theme defaultTheme="edit">
              <Translator namespace="hr.users">
                <ModelWithForm resourceName="users.users" operationContext={{ context: 'user_profile' }}
                               clean={true}>
                  <RedirectToEditOnCreatePipeline routeName="app.users.edit"/>

                  <Pipeline>
                    <TriggerPipelineOnBeforeThemeChange/>
                    <ResetSmartviewOnPipe/>
                  </Pipeline>

                  <WhenTheme type="edit">
                    <ConfirmFormChanges/>
                    <ManageUserPageHeader create={create}>
                      <UI.SubmitButton>
                        {create ? <Translation name="actions.create_user"/> : <Translation name="generic.save"/>}
                      </UI.SubmitButton>
                    </ManageUserPageHeader>
                    <UI.CardGroup>
                      <UI.FlexGrid cols={2}>
                        <PersonalInformationFieldset create={create}/>
                        <ContactInformationFieldset create={create}/>
                        <EmploymentInformationFieldset create={create}/>
                        <SystemAccessFieldset create={create}/>
                        <SalaryInformationFieldset create={create}/>
                      </UI.FlexGrid>
                    </UI.CardGroup>
                  </WhenTheme>
                  <WhenTheme type="contracts">
                    <ConfirmFormChanges/>
                    <ManageUserPageHeader create={create}/>
                    <UI.CardGroup>
                      <UI.FlexGrid>
                        <UserContractsView/>
                      </UI.FlexGrid>
                    </UI.CardGroup>
                  </WhenTheme>
                  <WhenTheme type="work_permits">
                    <ConfirmFormChanges/>
                    <ManageUserPageHeader create={create}>
                      <UI.SubmitButton>
                        {create ? <Translation name="actions.create_user"/> : <Translation name="generic.save"/>}
                      </UI.SubmitButton>
                    </ManageUserPageHeader>
                    <UI.CardGroup>
                      <UI.FlexGrid>
                        <UserWorkPermitsView/>
                      </UI.FlexGrid>
                    </UI.CardGroup>
                  </WhenTheme>

                </ModelWithForm>
        </Translator>
      </Theme>
    </AdminPageWithSmartview>
  )
}
